const ADACT_FREE_PLAY_DOMAIN = 'https://free-play.kenogo.com.au';

export { ADACT_FREE_PLAY_DOMAIN };
